export default {
  title: 'data and requirements',
  upload: 'upload data',
  sample: 'Sample',
  result: 'quality inspection result',
  qualified: 'qualified',
  unqualified: 'unqualified',
  editor: 'comments',
  choise: 'Select',
  enter: 'Enter content here',
  collectTemp0:	'Recording time requirement',
  collectTemp1:	'Shortest',
  collectTemp2:	'longest',
  js: {
    unfinished: 'unfinished',
    error: 'Error',
    nodatas: 'no data',
    finish: 'Please checking the task',
    whole: 'Please answer all questions',
    the: 'ID.',
    item: 'is not finished'
  },
  skip: 'Skip tasks',
  skip1: 'Reason',
  skip2: 'Rules do not apply',
  skip3: 'There is a problem with the data',
  skip4: 'The task is too difficult',
  skip5: 'Description',
  skip6: 'Please fill in the description'
}



// WEBPACK FOOTER //
// ./src/lang/en/collect.js